import type { Inspection, InspectionBE } from "@/views/inspection/inspection";
import { fillLookupValuesByPropertyNames, getLookupDescription, type Lookup } from "@modernary/mui/components/lookup";
import { ref } from "vue";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  requestAdapter,
  getInspectionTypeFromFacilitySiteTypeMetadata,
  // fromFormkit,
  // toFormkit,
  responseAdapter,
};

function addAuthRequestFields(entity: Inspection) {
  entity._authRequestFields = ["id", "facilitySiteId", "statusMurn", "inspector"] as (keyof Inspection)[];
  return entity;
}
function getInitialData() {
  const result = {
    typeMurn: null,
    inspectionDate: null,
    inspectionTime: null,
    contactPerson: "",
    contactPhone: "",
    contactEmail: "",
    comment: "",
    checklist: ref([]),
  } as unknown as Inspection; //TODO:TS
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Inspection }) {
  addAuthRequestFields(response.data);
  await fillLookupValuesByPropertyNames(response.data, ["typeMurn"]);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Inspection }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: Inspection) {
  // data is assumed to be from FormKit

  // Add seconds to the time so that the BE will parse it correctly.
  if (data.inspectionTime?.length === 5) {
    data.inspectionTime += ":00";
  }

  if (!data.inspectionDate) {
    data.inspectionDate = null;
  }

  if (!data.inspectionTime) {
    data.inspectionTime = null;
  }

  //switching to BE interface because facilitySite is required on IInspection,
  //but should not be sent back with request.
  const result = data as InspectionBE;
  delete result.facilitySite;
  return result;
}

function getInspectionTypeFromFacilitySiteTypeMetadata(metadata: Lookup["metadata"]) {
  if (metadata?.filtersOn?.inspectionTypeMurn?.values[0]) {
    return metadata.filtersOn.inspectionTypeMurn.values[0];
  }
  return undefined;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
// function toFormkit(data) {
// }

// // Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
// function fromFormkit(data) {
// }
